import React, { useState, useEffect } from "react";
import { Button, Pagination } from "rsuite";
import { numberFormatter } from "../../utils";
import PlusRoundIcon from "@rsuite/icons/PlusRound";
import MinusRoundIcon from "@rsuite/icons/MinusRound";
import { Row, Col } from "rsuite";


const ProductClass = (props: any) => {
  const [limit, setLimit] = React.useState(10);

  useEffect(() => {
    console.log(props.data);
  }, [props]);

  return (
    <>
      <div className="supplierTable">
        <div className="flex w-full gap-x-[2vh]">
          
            <div className="py-[1vh] font-bold" style={{border:0, background:'#b0ecdd',color:'black', width:'24%'}}>L1</div>
            <div className="py-[1vh] font-bold" style={{border:0, background:'#b0ecdd',color:'black',  width:'76%'}}>Product Class</div>
         
        </div>
        
         
                  <div
                    // key={d.name}
                    onClick={() => {
                    //   props?.updateSelectedItem(d.id);
                    }}
                    // className={`cursor-pointer ${
                    //   props.selectedItem === d.id
                    //     ? "bg-[#006400]"
                    //     : "bg-inherit"
                    // }`}
                    className="flex gap-x-[2vh]"
                  >
                    
                    <div className="pt-[1vh] flex h-fit justify-center" style={{border:0, width:'24%'}}><div style={{border:'2px solid white', padding:'1vh 2vh', width:'80%'}}>{props.data[0].l1}</div></div>
                    <div style={{border:0,  width:'76%'}}>
                        <div className="flex flex-wrap gap-[1vh] py-[1vh]">
                        {
                            props?.data?.map((d1:any, index:any)=>{
                                console.log('sss',d1);
                                return(
                                    <>
                                    <div>
                                <div className="recommededL4 truncate text-[1.3vh] pl-[1vh] pt-[.5vh]" style={
                                    props.selectedProduct == d1.l4 ? {
                                        height:'3vh',
                                        width:'10vh',
                                        color: 'black',
                                        boxShadow: '0px 0px 6px 6px #c52015', background: `linear-gradient(
                                        to right,
                                        #93d502 0,
                                        #93d502 ${(d1.currentRevenue / (d1.currentPortfolio + d1.currentRevenue)) * 100 + '%'},
                                        #e6f5c6 ${(d1.currentRevenue / (d1.currentPortfolio + d1.currentRevenue)) * 100 + '%'},
                                        #e6f5c6 100%
                                    )` } : {
                                        height:'3vh',
                                        width:'10vh',
                                        color: 'black',
                                        background: `linear-gradient(
                                    to right,
                                    #93d502 0,
                                    #93d502 ${(d1.currentRevenue / (d1.currentPortfolio + d1.currentRevenue)) * 100 + '%'},
                                    #e6f5c6 ${(d1.currentRevenue / (d1.currentPortfolio + d1.currentRevenue)) * 100 + '%'},
                                    #e6f5c6 100%
                                )`}}
                                    onClick={() =>{ props.updateSelectedProduct(d1.l4)
                                        props.updateSelectedL4(null);
                                    }}>
                                    <label style={{ cursor: "pointer" }}><b className="recommendedL4Name">{d1.l4}</b></label>
                                </div>
                                    <div className="flex justify-between">
                                    <span style={{ color: 'white', paddingRight:'1vh' }}>${ numberFormatter(d1.currentRevenue,0)}</span>
                                    <span style={{  color: 'white' }}>${d1.currentPortfolio < 0 ? 0 :  numberFormatter(d1.currentPortfolio,0)}</span>
                                    </div>
                                    </div>
                                    </>
                                )
                            })
                        }
                        </div>
                        
                    </div>
                  </div>
           
        
      </div>


      {/* <Row className="show-grid" >
          
            { <Col xs={24} sm={24} md={24}>
                <Row className="show-grid">
                    <Col className="costOppTitle" style={{marginLeft : '2px' , marginRight : '5px'}} xs={24} sm={24} md={5}>
                        <b> L1</b>
                    </Col>
                    <Col xs={24} sm={24} md={1} />
                    <Col className="costOppTitle" xs={24} sm={24} md={18}>
                        <b> Product Class</b>
                    </Col>
                </Row>
                 <Row style={{ marginTop: "1%" , height : '155px'}} className="show-grid">
                    <Col className="costOppSubTitle" style={{marginLeft : '2px' , marginRight : '5px'}} xs={24} sm={24} md={5}>
                        {props.data[0].l1}
                    </Col>
                    <Col xs={24} sm={24} md={1} />
                    <Col xs={24} sm={24} md={18} className="clickedDataAlign">
                        {props?.data?.sort((a:any,b:any) => b.currentRevenue-a.currentRevenue).map((d1: any) => <span className="recommededL4" style={
                            props.selectedL4 == d1.l4 ? {
                                boxShadow: '0px 0px 6px 6px #c52015', background: `linear-gradient(
                                to right,
                                #93d502 0,
                                #93d502 ${(d1.currentRevenue / (d1.currentPortfolio + d1.currentRevenue)) * 100 + '%'},
                                #e6f5c6 ${(d1.currentRevenue / (d1.currentPortfolio + d1.currentRevenue)) * 100 + '%'},
                                #e6f5c6 100%
                            )` } : {
                                background: `linear-gradient(
                            to right,
                            #93d502 0,
                            #93d502 ${(d1.currentRevenue / (d1.currentPortfolio + d1.currentRevenue)) * 100 + '%'},
                            #e6f5c6 ${(d1.currentRevenue / (d1.currentPortfolio + d1.currentRevenue)) * 100 + '%'},
                            #e6f5c6 100%
                        )`}}
                        onClick={() => props.updateSelectedL4(d1.l4)}>
                        <label style={{ cursor: "pointer" }}><b className="recommendedL4Name">{d1.l4}</b></label>
                        <span style={{ position: 'absolute', left: 0, top: '100%', color: 'white' }}>${ Math.round(d1.currentRevenue)}</span>
                        <span style={{ position: 'absolute', right: 0, top: '100%', color: 'white' }}>${d1.currentPortfolio < 0 ? 0 :  Math.round(d1.currentPortfolio)}</span>
                        </span>)}
                    </Col>
                </Row>
            </Col> }
        </Row> */}
     
    </>
  );
};
export default ProductClass;
